import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface RecordPageShellProps {
  children: ReactNode;
  className?: string;
  pageFill?: boolean;
}

export function RecordPageShell({
  children,
  className,
  pageFill = true,
}: RecordPageShellProps) {
  return (
    <div
      data-page-fill={pageFill ? "" : undefined}
      className={cn(
        "flex flex-col",
        pageFill && "min-h-0 flex-1 max-md:min-h-[min(32rem,70dvh)]",
        className,
      )}
    >
      {children}
    </div>
  );
}
